import Api from 'services/api';

export const getConfig = () => {
  return (
    new Promise((resolve, reject) => {
      Api.get('/config').then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    })
  );
};
